var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 169,
    viewBox: "0 0 221 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M220.817 64.8534C220.8 64.9819 220.774 65.1105 220.749 65.239L220.732 65.2904L220.654 65.5475L202.256 130.872L201.802 130.812C201.99 131.858 201.682 132.989 200.816 133.803C191.673 142.467 165.133 167.284 159.52 168.655C152.819 170.335 144.009 165.253 135.5 161.122L21.9035 107.615L20.5409 106.972C20.4038 106.904 20.2667 106.826 20.1468 106.749C19.0499 105.987 18.7071 104.538 19.2469 103.399L0.488464 33.5835L0 31.7582V31.7497C0 31.7411 0 31.7411 0 31.7411C0.0257083 30.8499 0.419888 29.9672 1.21685 29.3502C2.72507 28.1762 4.7132 27.1479 6.70131 26.1195L56.3869 1.89376C58.5207 0.82258 60.9887 0.64262 63.2596 1.39673C85.3087 8.71503 194.303 48.4772 218.641 60.7144C220.26 61.5456 221.031 63.2338 220.817 64.8534Z",
    fill: "url(#paint0_linear_59_1808)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_1808",
    x1: 112.815,
    y1: -0.641252,
    x2: 106.949,
    y2: 119.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2DA5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C17530"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5);
export default __webpack_public_path__ + "static/media/Group_5.9b24058d65fbb8541bdfbd77f2056880.svg";
export { ForwardRef as ReactComponent };